module.exports = __webpack_public_path__ + "static/forecr1-6d5ab702ac406fd0abc4814b179ce2d6.png";